import '../classes/styles/style.css';
import { Link } from 'react-router-dom';

type SidenavProps = {
    isHidden?: boolean;
};

export default function Sidenav(props: SidenavProps): JSX.Element {
    const pathname = window.location.pathname; 

    // Controllo per verificare se l'utente è su un dispositivo mobile
    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

    // Override di isHidden se il dispositivo è mobile
    const isHidden = isMobile ? true : props.isHidden;

    return (
        <div id="sidenav" className={isHidden ? 'sidenav-hide' : ''}>
            <div className='sidenavHeader'>
                <img src="/assets/img/logo/AYCW_ICN_WHT.png" alt="" />
            </div>
            <div className='sidenavBody'>
                <ul>
                    <li className={pathname === '/home/' ? 'active' : ''}>
                        <Link to={'/home/'}>
                            <i className="bi bi-house"></i>
                            <span className='ms-3'>Home</span>
                        </Link>
                    </li>
                    <li className={pathname === '/sedi/' ? 'active' : ''}>
                        <Link to={'/sedi/'}>
                            <i className="bi bi-buildings"></i>
                            <span className='ms-3'>Sedi</span>
                        </Link>
                    </li>
                    <li className={pathname === '/clienti/' ? 'active' : ''} >
                        <Link to={"/clienti/"}>
                            <i className="bi bi-people"></i>
                            <span className='ms-3'>Clienti</span>
                        </Link>
                    </li>
                    <li className={pathname === '/abbonamenti/' ? 'active' : ''}>
                        <Link to={"/abbonamenti/"}>
                            <i className="bi bi-file-earmark-check"></i>
                            <span className='ms-3'>Abbonamenti</span>
                        </Link>
                    </li>
                    <li className={pathname === '/promozioni/' ? 'active' : ''}>
                        <Link to="/promozioni/">
                        <i className="bi bi-tag"></i>
                            <span className='ms-3'>Promozioni</span>
                        </Link>
                    </li>
                    <li className={pathname === '/ordini/' ? 'active' : ''}>
                        <Link to="/ordini/">
                        <i className="bi bi-basket"></i>
                            <span className='ms-3'>Ordini</span>
                        </Link>
                    </li>
                    <li className={pathname === '/prenotazioni/' ? 'active' : ''}>
                        <Link to="/prenotazioni/">
                            <i className="bi bi-calendar-check"></i>
                            <span className='ms-3'>Prenotazioni</span>
                        </Link>
                    </li>
                </ul>
            </div>
        </div>
    );
}